import { CreateParams } from '..'
import { Element, Group, Rect } from 'zrender'
import { createImage, createText } from '../helpers'

/**
 * Create a list tile.
 */
export function list({ width, tile }: CreateParams<Tile & { type: 'list' }>) {
    const elements: Element[] = []
    const perLine = tile.itemsPerLine ?? Math.round(tile.items.length / 2)
    const groupSize = width / perLine
    const padding = 0.1
    const rectSize = groupSize * (1 - padding * 2)
    const contentSize = rectSize * (1 - padding)

    let y = 0

    if (tile.title) {
        const title = createText(tile.title, 'lg', width)
        title.y = y
        elements.push(title)
        y += title.getBoundingRect().height + 5
    }

    if (tile.subtitle) {
        const subtitle = createText(tile.subtitle, 'md', width)
        subtitle.y = y
        elements.push(subtitle)
        y += subtitle.getBoundingRect().height + 5
    }

    if (tile.text) {
        const text = createText(tile.text, 'md', width)
        text.y = y
        y += text.getBoundingRect().height
        elements.push(text)
    }

    for (let i = 0; i < tile.items.length; i++) {
        const item = tile.items[i]
        const col = i % perLine
        const group = new Group({
            x: col * groupSize + groupSize * padding,
            y: y + 20
        })

        const rect = new Rect({
            shape: {
                width: rectSize,
                height: rectSize,
                r: 5
            },
            style: {
                fill: 'transparent',
                stroke: 'black',
                lineWidth: 1
            }
        })

        group.add(rect)

        const icon = createImage(item.icon)

        const text = createText(item.label, 'sm', contentSize)
        text.setStyle({
            align: 'center',
            verticalAlign: 'bottom',
            overflow: 'truncate'
        })
        text.x = rectSize / 2
        text.y = contentSize
        group.add(text)

        const textHeight = text.getBoundingRect().height + 10
        const size = contentSize - textHeight

        icon.setStyle({
            width: size,
            height: size,
            x: (rectSize - size) / 2,
            y: (rectSize - size - textHeight) / 2
        })

        group.add(icon)

        if (col === perLine - 1) {
            y += group.getBoundingRect().height + 10
        }

        elements.push(group)
    }

    return elements
}
